import { type MouseEvent, type ReactNode, useState } from 'react';
import { Menu as MuiMenu, type MenuProps as MuiMenuProps } from '@mui/material';

type MenuRenderProps = { close: () => void };

type MenuProps = Omit<MuiMenuProps, 'open' | 'anchorEl' | 'onClose' | 'children'> & {
  trigger: (props: { onClick: (event: MouseEvent<HTMLElement>) => void }) => ReactNode;
  children: ReactNode | ((props: MenuRenderProps) => ReactNode);
};

export const Menu = (props: MenuProps) => {
  const {
    trigger,
    children,
    anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
    transformOrigin = { vertical: 'top', horizontal: 'left' },
    ...menuProps
  } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {trigger({ onClick: handleOpen })}
      <MuiMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        {...menuProps}
      >
        {typeof children === 'function' ? children({ close: handleClose }) : children}
      </MuiMenu>
    </>
  );
};
